import { Reveal } from "./Reveal";
import { Eyebrow } from "./Shared";

const steps = [
  {
    year: "2012-ish",
    title: "The first P&L",
    copy: "Fifteen. A real company from his father. The education that cannot be downloaded.",
  },
  {
    year: "Film",
    title: "Polyglot",
    em: true,
    copy: "Seventy people. Film production. Budget, logistics, talent, delivery. Proof he can run a room that is not a Slack channel.",
  },
  {
    year: "2021",
    title: "Australia + ATS Corporate",
    copy: "Applied blockchain diploma in Gold Coast. Still operating. Research that becomes a company.",
  },
  {
    year: "Oct 2021",
    title: "u-topia is born",
    copy: "Founded to make Web3 usable: ownership, entertainment, a wallet a teenager could hold without getting hurt. The seed of everything after.",
  },
  {
    year: "2025-26",
    title: "The rails chapter",
    copy: "From media and tokens toward the thing he is actually obsessed with: banking-like software for people who live in more than one country. U-App. Cards. Community as distribution.",
  },
  {
    year: "2026",
    title: "u-topia goes global",
    copy: "U.CENTER goes live in May. First u-topia transactions in June. World tour. Bangkok Summit 15-16 October. Public launch of the super app on the 16th.",
  },
];

export default function Path() {
  return (
    <section id="path" data-testid="path-section" className="scroll-mt-20 bg-brand-n3 py-24 lg:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6">
        <Reveal>
          <Eyebrow>Path</Eyebrow>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-navy sm:text-4xl lg:text-5xl">
            A short history of{" "}
            <span className="text-brand-orange">taking the long way.</span>
          </h2>
        </Reveal>

        <ol className="relative ml-2 mt-16 space-y-12 border-l border-navy/15 pl-8 sm:ml-4 sm:pl-12">
          {steps.map((s, i) => (
            <li key={s.title} className="relative">
              <span
                aria-hidden="true"
                className="absolute -left-[41px] top-1.5 h-4 w-4 rounded-full bg-brand-orange ring-4 ring-brand-n3 sm:-left-[57px]"
              />
              <Reveal delay={i * 0.05}>
                <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand-orange">
                  {s.year}
                </p>
                <h3 className="mt-1.5 text-xl font-semibold tracking-tight text-navy sm:text-2xl">
                  {s.em ? <em>{s.title}</em> : s.title}
                </h3>
                <p className="mt-2.5 max-w-2xl leading-relaxed text-navy/70">{s.copy}</p>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
